import React from 'react'

interface QueryErrorProps {
  message: string
  onRetry: () => void
}

export const QueryError: React.FC<QueryErrorProps> = ({ message, onRetry }) => (
  <div className="flex flex-row flex-wrap items-center gap-x-3 gap-y-1 text-sm text-red-600 dark:text-red-400">
    <span>{message}</span>
    <button
      type="button"
      onClick={onRetry}
      className="rounded-md border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-700"
    >
      Retry
    </button>
  </div>
)

export default QueryError
